import React from 'react';
import Print from "../svgs/Print";
import PrintComponents from "react-print-components";
import { StyledPrintButton, StyledPrintLabel } from "./styles";
import PropTypes from "prop-types";

export default function PrintButton({
  className,
  buttonLabel = "PRINT",
  children,
  printClick,
  id
}) {
  return (
    <div className={className} onClick={printClick}>
      <PrintComponents
        trigger={
          <StyledPrintButton id={id ? id : null}>
            <Print />
            <StyledPrintLabel>{buttonLabel}</StyledPrintLabel>
          </StyledPrintButton>
        }
      >
        {children}
      </PrintComponents>
    </div>
  )
}

PrintButton.propTypes = {
  buttonLabel: PropTypes.string,
  printClick: PropTypes.func
}
